import { render, staticRenderFns } from "./globalConfirmDialog.vue?vue&type=template&id=6c97438c"
import script from "./globalConfirmDialog.vue?vue&type=script&lang=js"
export * from "./globalConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports